import * as yup from 'yup';
import { useState } from 'react';
import { MetaDataCategory } from 'types/api/envScales/MetaDataCategory';
import { Input } from 'components/Measure/Input';
import { updateCycleMetaData } from 'actions/envScales/observationCycles';
import { ObservationCycle } from 'types/api/envScales/ObservationCycle';
import { Assessment } from 'types/api/envScales/Assessment';
import { useServerFieldError } from 'components/Measure/View/ValidationsContext';

interface MetaDataFieldsProps {
  /**field information */
  fields: MetaDataCategory;

  /**default value of the field */
  defaultValue: string;

  /** Observation Cycle. */
  cycle: ObservationCycle;

  /** CLASS Assessment. */
  assessment: Assessment;

  /** Callback fired when the value changes. */
  onChange?: (value: string) => void;
}

function MetaDataFields({
  fields,
  defaultValue,
  cycle,
  assessment,
  onChange
}: MetaDataFieldsProps) {
  const [currentValue, setCurrentValue] = useState(defaultValue);

  const serverFieldError = useServerFieldError(
    `cycles.${cycle.cycle_number}.details.${fields.t_name}`,
    currentValue,
    yup.number().required()
  );

  function handleMetaDataValues(categoryId: number) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
      const observationId = assessment.observation!.id;
      const payloadMetaData = {
        meta_data: {
          meta_data_category_id: categoryId,
          values: event.target.value
        }
      };
      setCurrentValue(event.target.value);
      updateCycleMetaData(observationId, cycle.id, payloadMetaData);
      onChange?.(event.target.value);
    };
  }

  return (
    <Input
      min="0"
      fluid
      key={fields.t_name}
      required
      type="number"
      name={fields.t_name}
      label={fields.name}
      onChange={handleMetaDataValues(fields.id)}
      defaultValue={defaultValue}
      errorMessage={serverFieldError?.message ?? null}
    />
  );
}

export default MetaDataFields;
